import React from 'react';
import PageHero from '@/components/PageHero';
import SEO from '@/components/SEO';
import { WORK_HISTORY, TASK_FORCES, TRAINING } from '@/data/content';
import { Briefcase, GraduationCap, Users } from 'lucide-react';

export default function Bio() {
  return (
    <div>
      <SEO
        title="Bio — Lt. Joseph M. Kress"
        description="Bio of Lt. Joseph M. Kress: 25+ years of decorated Erie Police service, narcotics investigations, and drug awareness education."
        path="/bio"
      />
      <PageHero
        title="Lt. Joseph M. Kress"
        subtitle="25+ years of decorated law enforcement service, narcotics investigations, and drug awareness education."
        image="https://images.unsplash.com/photo-1709507531336-3e681fd91956?auto=format&fit=crop&w=1920&q=80"
        crumbs={['Bio']}
      />

      <div className="max-w-5xl mx-auto px-4 py-16">
        {/* Work History */}
        <SectionHeader icon={<Briefcase className="h-5 w-5" />} eyebrow="Career" title="Work History" />
        <div className="space-y-6 mb-16">
          {WORK_HISTORY.map((w, i) => (
            <div key={i} className="grid md:grid-cols-[180px_1fr] gap-4 md:gap-8 pb-6 border-b border-slate-200 last:border-none">
              <div>
                <div className="text-sm font-bold text-amber-600 tracking-wide">{w.period}</div>
                <div className="text-xs text-slate-500 mt-1">{w.dept}</div>
              </div>
              <div>
                <h4 className="font-serif text-lg font-bold text-[#0b2545] mb-2">{w.title}</h4>
                <p className="text-slate-700 leading-[1.85] text-[15px]">{w.body}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Task Forces */}
        <SectionHeader icon={<Users className="h-5 w-5" />} eyebrow="Assignments" title="Task Force Assignments" />
        <ul className="grid md:grid-cols-2 gap-3 mb-16">
          {TASK_FORCES.map((t, i) => (
            <li key={i} className="flex items-center gap-3 bg-white p-4 rounded-md border border-slate-200">
              <span className="h-2 w-2 rounded-full bg-amber-500" />
              <span className="text-slate-700">{t}</span>
            </li>
          ))}
        </ul>

        {/* Training */}
        <SectionHeader icon={<GraduationCap className="h-5 w-5" />} eyebrow="Education" title="Formal Police Education & Training" />
        <div className="grid md:grid-cols-2 gap-4">
          {TRAINING.map((t, i) => (
            <div key={i} className="p-5 bg-white rounded-md border border-slate-200 hover:border-amber-300 transition-colors">
              <div className="font-serif font-bold text-[#0b2545] mb-1">{t.title}</div>
              <div className="text-sm text-slate-600">{t.org}</div>
              <div className="text-xs text-amber-600 font-semibold mt-2">{t.date}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function SectionHeader({ icon, eyebrow, title }) {
  return (
    <div className="mb-8">
      <div className="flex items-center gap-2 text-amber-600 mb-2">
        {icon}
        <span className="text-xs uppercase tracking-[0.3em] font-semibold">{eyebrow}</span>
      </div>
      <h2 className="font-serif text-3xl font-bold text-[#0b2545]">{title}</h2>
      <div className="mt-3 h-1 w-16 bg-amber-400" />
    </div>
  );
}
